if (typeof ScrollingText !== 'function') {
  class ScrollingText extends HTMLElement {
    constructor() {
      super()

      if (window.innerWidth < 1024) {
        this.classList.remove('static')
      }

      const ScrollingText = (function () {
        function getWidth(element) {
          const rect = element.getBoundingClientRect()
          return rect.right - rect.left
        }
        function ScrollingText(box, speed) {
          const innerElement = (box.children && box.children[0]) || null
          if (!innerElement) throw new Error('No child node found')

          innerElement.style.position = 'relative'

          this.position = 0
          this.speed = speed
          this.box_width = getWidth(box)
          this.innerElement_width = getWidth(innerElement)
          this.box = box
          this.innerElement = innerElement.cloneNode(true)
          setUpChildrens.call(this)
        }

        function refreshWidths() {
          this.box_width = getWidth(this.box)
          this.innerElement_width = getWidth(this.box.children[0])
        }

        function calculateNumElements() {
          return Math.ceil(this.box_width / this.innerElement_width) + 1
        }

        function setUpChildrens() {
          if (window.innerWidth > 1023) return

          const qty = calculateNumElements.call(this)
          if (qty > this.box.children.length) {
            for (let i = this.box.children.length; i < qty; i += 1)
              this.box.appendChild(this.innerElement.cloneNode(true))
          } else if (qty < this.box.children.length) {
            for (let i = qty; i < this.box.children.length; i += 1)
              this.box.removeChild(this.box.lastChild)
          }
        }

        function nextFrame(delta, direction) {
          const self = this
          refreshWidths.call(this)
          setUpChildrens.call(this)
          Array.prototype.forEach.call(this.box.children, function (el) {
            if (direction === 'rtl') {
              el.style.transform = `translateX(${self.position}px)`
            } else {
              el.style.transform = `translateX(${-self.position}px)`
            }
          })
          this.position += (this.speed * delta) / 1000
          if (this.position >= this.innerElement_width)
            this.position = this.position % this.innerElement_width
        }

        ScrollingText.prototype = {
          start: function (direction, speed) {
            // No Scrolling for Desktop
            if (window.innerWidth > 1023) return

            this._running = true
            let self = this
            let last_time = null
            let loop_func = function () {
              if (!self._running) return
              let now = Date.now()
              let delta = last_time === null ? 0 : now - last_time
              nextFrame.call(self, delta, direction, speed)
              last_time = now
              window.requestAnimationFrame(loop_func)
            }
            window.requestAnimationFrame(loop_func)
          },

          stop: function () {
            this._running = false
          },
        }

        return ScrollingText
      })()

      const speed =
        window.innerWidth > 768
          ? parseInt(this.dataset.scrollingSpeed)
          : parseInt(this.dataset.scrollingSpeed) / 1.5
      const direction = this.dataset.scrollingDirection
      const scrollingText = new ScrollingText(this, speed, direction)

      const intersectionObserver = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          scrollingText.start(direction)
        } else {
          scrollingText.stop()
        }
      })
      intersectionObserver.observe(this)
    }

  }

  if (typeof customElements.get('scrolling-text') === 'undefined') {
    customElements.define('scrolling-text', ScrollingText)
  }
}
